<template>
  <div class="pages-box">
    <h2>Sayfa Yönetimi</h2>

    <div class="form-section">
      <h3>{{ editingId ? 'Sayfayı Düzenle' : 'Yeni Sayfa Ekle' }}</h3>
      <form @submit.prevent="savePage">
        <input v-model="form.title" type="text" placeholder="Başlık" required />
        <input v-model="form.slug" type="text" placeholder="Slug (örnek: hakkimizda)" required />
        <Editor
          v-model="form.content"
          :init="editorInit"
          api-key="no-api-key"
        />
        <button type="submit" class="btn green">Kaydet</button>
      </form>
    </div>

    <div class="page-list">
      <div v-for="page in pages" :key="page.id" class="page-item">
        <h4>{{ page.title }}</h4>
        <small>Slug: /sayfa/{{ page.slug }}</small>
        <div v-html="page.content" class="preview"></div>
        <div class="actions">
          <button class="btn" @click="editPage(page)">Düzenle</button>
          <button class="btn red" @click="deletePage(page.id)">Sil</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import Editor from '@tinymce/tinymce-vue';
import { getToken } from '@/utils/auth'
const baseURL = process.env.VUE_APP_API_URL
const pages = ref([])
const form = ref({ title: '', slug: '', content: '' })
const editingId = ref(null)

const editorInit = {
  height: 300,
  menubar: false,
  plugins: 'lists link image code fullscreen table',
  toolbar: 'undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | link image | code fullscreen'
}

async function fetchPages() {
  const res = await fetch(`${baseURL}/admin/pages`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  })
  pages.value = await res.json()
}

function editPage(page) {
  form.value = {
    title: page.title,
    slug: page.slug,
    content: page.content
  }
  editingId.value = page.id
}

async function deletePage(id) {
  if (!confirm('Silmek istediğinize emin misiniz?')) return
  const res = await fetch(`${baseURL}/admin/pages/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` }
  })
  if (res.ok) {
    alert('Silindi.')
    fetchPages()
  } else {
    alert('Silinemedi.')
  }
}

async function savePage() {
  const url = editingId.value
    ? `${baseURL}/admin/pages/${editingId.value}`
    : `${baseURL}/admin/pages`

  const method = editingId.value ? 'PUT' : 'POST'

  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify(form.value)
  })

  if (res.ok) {
    alert('Sayfa kaydedildi.')
    form.value = { title: '', slug: '', content: '' }
    editingId.value = null
    fetchPages()
  } else {
    alert('Kaydedilemedi.')
  }
}

watch(() => form.value.title, (newTitle) => {
  if (!editingId.value) {
    form.value.slug = newTitle.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
  }
})

onMounted(fetchPages)
</script>

<style scoped>
.pages-box {
  max-width: 1000px;
  margin: auto;
}
.form-section {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 30px;
}
input[type="text"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
}
.page-item {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 12px;
}
.preview {
  margin: 12px 0;
  font-size: 0.9em;
  color: #333;
}
.actions {
  display: flex;
  gap: 10px;
}
.btn {
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  background-color: #2980b9;
  color: white;
  cursor: pointer;
}
.btn.green {
  background-color: #27ae60;
}
.btn.red {
  background-color: #e74c3c;
}
</style>
